import { jsx as _jsx } from "react/jsx-runtime";
import { ProductStub } from '../ProductStub';
/** Uptime Alert Rules — Wave 1 target (mirrors the SSL page). */
export function AlertRulesPage() {
    return (_jsx(ProductStub, { title: "Alert rules", blurb: "Decide when uptime alerts fire \u2014 consecutive-failure threshold before a monitor is marked DOWN, re-notify cadence while it stays down, recovery (UP) notifications, and maintenance windows that mute alerts. Ships in Wave 1." }));
}
